<span class="alert alert-type-{{type}}"><ng-content></ng-content></span>
